import { env } from "build/env";
export var pushToMiScusi = (historyPush, url) => {
  if (!(historyPush && historyPush.bind)) {
    throw new Error("the first argument should be the actual history.push");
  }
  window.location.href = "".concat(env.URL_MISCUSI).concat(url || "/");
};
export var homepageUrl = "/homepage";
export var pushToWebsiteHomepage = () => {
  var {
    URL_MISCUSI
  } = env;
  var websiteHomepageUrl = "".concat(window.location.protocol, "//").concat(URL_MISCUSI);
  window.location.assign(websiteHomepageUrl);
};